import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../../app/providers';

export const versionKeys = { list: (boardId: string) => ['versions', boardId] as const };

/** The board's versions and the history's writes; every write refreshes the list. */
export function useVersions(boardId: string, enabled = true) {
  const api = useApi();
  const queryClient = useQueryClient();
  const list = useQuery({ queryKey: versionKeys.list(boardId), queryFn: () => api.listVersions(boardId), enabled });
  const refresh = () => queryClient.invalidateQueries({ queryKey: versionKeys.list(boardId) });
  const create = useMutation({ mutationFn: (label: string) => api.createVersion(boardId, label), onSettled: refresh });
  const remove = useMutation({ mutationFn: (versionId: string) => api.deleteVersion(versionId), onSettled: refresh });
  return { list, create, remove, refresh };
}
